// extracted by mini-css-extract-plugin
export default {"results":"styles_results__SCrZL","loader":"styles_loader__JIEww","noResults":"styles_noResults__+Zntk"};